<template>
    <transition name="slide">
        <div class="item-tray small">
            <b-container>
                <b-overlay :show="loading" rounded="lg" opacity="0.6">
                    <ion-icon @click="closeModifier" name="play" class="close-icon"></ion-icon>
                    <h1  class="h5 text-center">{{ itemDetails.name }}</h1>
                    <h2 class="text-center">£{{ formatMoney(itemDetails.price) }} </h2>
                    <div class="tray-inner">
                        <table class="table modifier-table">
                            <tbody>
                            <tr v-for="(modifier, index) in modifiers" :key="index">
                                <td>{{ modifier.name }} <br>( £{{formatMoney(modifier.price)}} )</td>
                                <td>
                                    <b-form-checkbox @change="alterTotalPrice($event, modifier)"
                                                     v-model="selectedModifiers" :value="modifier" size="lg"></b-form-checkbox>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <span v-if="modifiers.length > 0" class="pt-2 d-block text-center text-muted">Scroll down for more options.</span>

                    <b-btn class="mt-4" size="lg" variant="primary" @click="addProductToCart" block>Add to order</b-btn>
                </b-overlay>

            </b-container>
        </div>
    </transition>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: "ModifierSheet",
        props: ['item_id'],
        data() {
            return {
                quantity: 1,
                originalPrice: 0,
                selectedModifiers: [],
                modifiers: [],
                itemDetails: '',
                loading: false,
            }
        },

        watch: {
            item_id: function(newVal, oldVal) { // watch it
                this.getItemDetails(newVal)
            },
        },

        methods: {
            ...mapActions([
                'addProduct',
            ]),

            addProductToCart() {
                this.loading = true;
                let itemData = {
                    'quantity': this.quantity,
                    'selectedModifiers': this.selectedModifiers,
                    'itemDetails': this.itemDetails,
                    'total': this.itemDetails.price
                }
                this.addProduct(itemData)
                this.loading = false;
                swal({
                    title: 'Item added to cart',
                    icon: 'success',
                })
                this.selectedModifiers = [];
                this.itemDetails.price = this.originalPrice;
                this.$emit('close');
            },

            getItemDetails() {
                this.loading = true;
                axios.get('/item/details/' + this.item_id).then(response => {
                    this.itemDetails = response.data.itemDetails;
                    this.originalPrice = response.data.itemDetails.price;
                    this.getModifiers();
                    this.loading = false
                });
            },

            getModifiers() {
                // get modifiers
                axios.get('/items/modifiers/' + this.item_id).then(response => {
                    this.modifiers = response.data;
                    console.log('modifiers', this.modifiers);
                })
            },

            alterTotalPrice(id, modifier) {
                console.log('id', id)
                console.log('modifier', modifier)
                if (id) {
                    console.log(modifier)
                    this.selectedModifiers.push(modifier);
                    this.itemDetails.price = parseFloat(this.itemDetails.price) + parseFloat(modifier.price);
                } else {
                    const index = this.selectedModifiers.indexOf(modifier);
                    if (index > -1) {
                        this.selectedModifiers.splice(index, 1);
                    }
                    this.itemDetails.price = this.itemDetails.price - modifier.price;
                }
            },

            formatMoney(quantity, decimalCount = 2, decimal = ".", thousands = ",") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = quantity < 0 ? "-" : "";

                    let i = parseInt(quantity = Math.abs(Number(quantity) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(quantity - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.log(e)
                }
            },

            closeModifier() {
                this.selectedModifiers = [];

                this.itemDetails.price = this.originalPrice;
                console.log('original_price', this.itemDetails.price)
                this.$emit('close');
            }
        }
    }
</script>

<style scoped>
    .slide-enter-active {
        animation: slide-in .5s;
    }

    .slide-leave-active {
        animation: slide-in .5s reverse;
    }

    @keyframes slide-in {
        0% {
            transform: translateY(100%);
        }
        100% {
            transform: translateY(0);
        }
    }
</style>
